import React from "react";
import { Tooltip } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import alertIconDefinition from "@ant-design/icons-svg/es/asn/ExclamationCircleOutlined";
import { renderIconDefinitionToSVGElement } from "@ant-design/icons-svg/es/helpers";

export const ALERT_COLOR = "#cf1322";
/** What an alert impact is. The tooltip of the icon shows it everywhere on the tab. */
export const ALERT_EXPLANATION = "Riddell flagged this impact as above its alert threshold.";

const label = (count?: number) =>
  count == null ? "Alert impact" : `${count} alert ${count === 1 ? "impact" : "impacts"}`;

/** The alert icon with its explanation on hover. With `count`, the cell shows the count alone. */
export function AlertIcon({ count }: { count?: number }) {
  return (
    <Tooltip title={count == null ? ALERT_EXPLANATION : `${label(count)}. ${ALERT_EXPLANATION}`}>
      {count == null ? (
        <span className="helmet-alert" aria-label={label(count)}>
          <ExclamationCircleOutlined />
        </span>
      ) : (
        <span className="helmet-alert-count" aria-label={label(count)}>
          {count}
        </span>
      )}
    </Tooltip>
  );
}

/** The same icon as an SVG string, for the HTML labels of the Highcharts chart. */
export const ALERT_ICON_SVG = renderIconDefinitionToSVGElement(alertIconDefinition, {
  extraSVGAttrs: { width: "1em", height: "1em", fill: ALERT_COLOR, style: "vertical-align:-0.125em" },
});
